import React from "react";
import dayjs from "dayjs";

export const SurveyTimeline: React.FC<{ surveys: any[] }> = ({ surveys }) => {
    if (!surveys || surveys.length === 0) {
        return <p className="text-sm text-slate-500 py-4">No surveys found</p>;
    }

    const formatDateTime = (date: string | undefined) => {
        if (!date) return "N/A";
        return dayjs(date).format("DD/MM/YYYY h:mm:ss a");
    };

    return (
        <div className="max-h-96 overflow-y-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50 sticky top-0">
                    <tr>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            S.no.
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Start Time and Date
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Survey Id
                        </th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {surveys.map((survey, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                {index + 1}
                            </td>
                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                {formatDateTime(survey["dates"]?.start)}
                            </td>
                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                                {survey["clientid"] || "N/A"}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
